export const poll = (fn, timeout = 5000, interval = 100, isPollComplete) => {
  const endTime = Number(new Date()) + timeout;

  const checkCondition = function (resolve, reject) {
    const ajax = fn();
    // dive into the ajax promise
    ajax
      .then((response) => {
        if (response.status == 200) {
          if (isPollComplete && typeof isPollComplete === 'function') {
            if (isPollComplete(response)) {
              // If the condition is met, we're done!
              clearTimeout(timeout);
              return resolve(response);
            } else {
              timeout = setTimeout(checkCondition, interval, resolve, reject);
            }
          } else {
            // If the condition is met, we're done!
            clearTimeout(timeout);
            return resolve(response);
          }
        } else if (Number(new Date()) < endTime) {
          // If the condition isn't met but the timeout hasn't elapsed, go again
          timeout = setTimeout(checkCondition, interval, resolve, reject);
        } else {
          // Didn't match and too much time, reject!
          clearTimeout(timeout);
          reject(new Error('timed out for ' + fn + ': ' + arguments));
        }
      })
      .catch(() => {
        timeout = setTimeout(checkCondition, interval, resolve, reject);
      })
      .finally(() => {
        if (Number(new Date()) > endTime) {
          clearTimeout(timeout);
          reject(new Error('timed out for ' + fn + ': ' + arguments));
        }
      });
  };

  return new Promise(checkCondition);
};
